<script>
import { getOneWorkoutLogFromDbase, deleteOneWorkoutLog } from '@/services/WorkoutServices';
export default {
  props: [ 'workoutId' ],
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),
      //
      workout: {},
      //
      showDeleteWorkoutModal: false,
    };
  },
  methods: {
    async clickedDeleteThisWorkout() {
      // console.log('*** starting clickedDeleteThisWorkout() ***', this.workoutId);
      this.showDeleteWorkoutModal = true;
    },
    async forrealForrealDeleteOneWorkoutLog() {

      // do the delete
      await deleteOneWorkoutLog(this.uId, this.token, this.workoutId);
      await this.$nextTick();

      // redirect
      this.$router.push('/workouts');

    },
  },
  async created() {
    console.clear();
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });


    this.workout = await getOneWorkoutLogFromDbase(this.uId, this.token, this.workoutId);

    // console.log('*** got workout ***', this.workout);
  },
}
</script>

<template>
<div id="page-workout-one" class="px-4 pb-16">

  <div id="page-header" class="py-4 text-center">
    <h1>Workout Log</h1>
  </div>


  <!-- THIS WORKOUT EXISTS -->
  <div v-if="workout?.date">
    <div id="logistics">
      <p><b>Date:</b> {{ workout?.date?.display }}</p>
      <p><b>Time:</b> {{ workout?.time }}</p>
      <p class="allow-pre-line"><b>Location:</b> {{ workout?.location || ' n/a' }}</p>
      <p class="allow-new-line"><b>General Notes:</b> {{ workout.generalNotes || ' n/a' }}</p>
    </div>


    <div id="warmup" class="my-8">
      <h3><u>Warm-Up</u></h3>
      <p class="allow-new-line">{{ workout.warmup || 'n/a'}}</p>
    </div>


    <div id="workout">
      <h3><u>Workout</u></h3>

      <!-- one single exercise -->
      <div v-for="(exercise, exerciseIndex) in workout.workout"
           :key="exerciseIndex"
           class="one-exercise pa-2 mb-6 bg-grey-lighten-4 rounded-lg"
      >
        <h4 class="text-uppercase">{{ exercise.exerciseName }}</h4>

        <p v-if="exercise.exerciseNote"
           class="text-body-2 font-italic allow-new-line"
        >
          <b>Exercise Note/Description:</b> {{ exercise.exerciseNote }}
        </p>

        <div class="d-flex justify-center">
          <div class="py-3 w-33 text-center font-weight-bold border">#</div>
          <div class="py-3 w-33 text-center font-weight-bold border">Reps</div>
          <div class="py-3 w-33 text-center font-weight-bold border">Weight</div>
        </div>

        <div v-for="(set, setIndex) in exercise.sets" :key="setIndex"
             class="pt-4 d-flex justify-center flex-wrap"
        >
          <div class="w-33 text-center font-weight-bold">Set {{ setIndex+1 }}</div>
          <div class="w-33 text-center">{{ set.reps }}</div>
          <div class="w-33 text-center">{{ set.weight }}</div>
          <div v-if="set.note" class="mx-12 w-100 allow-new-line text-body-2 font-italic">{{ set.note }}</div>
          <hr v-if="setIndex < exercise.sets.length -1" class="mt-4 w-100" />
        </div>

      </div> <!-- end exercise -->

    </div> <!-- end #workout -->

    <div id="cooldown" class="my-8">
      <h3><u>Cool-Down</u></h3>
      <p class="allow-new-line">{{ workout.cooldown || 'n/a' }}</p>
    </div>

  </div>
  <!-- end WORKOUT EXISTS -->


  <!-- THIS WORKOUT DOES NOT EXIST -->
  <div v-else class="mt-12 text-center">
    <p><b>Hmm, something went wrong.</b></p>
    <p>There is no Workout Log on this date.</p>
    <p>Please <router-link to="/workouts">go back</router-link> and try again.</p>
  </div>
  <!-- end WORKOUT DOES NOT EXIST -->


  <!-- BUTTONS -->
  <div class="my-16 pt-4 d-flex flex-column align-center">
    <router-link to="/workouts">
      <v-btn color="green-lighten-2"
             density="comfortable"
             class="text-white"
      >Go back to All Workouts</v-btn>
    </router-link>
    <v-btn @click.prevent="clickedDeleteThisWorkout"
           variant="outlined"
           size="sm"
           color="red-lighten-2"
           class="mt-12 pa-1 text-capitalize"
    >Delete this Workout Log</v-btn>
  </div>
  <!-- end BUTTONS -->


  <!-- MODAL: ARE YOU SURE YOU WANT TO DELETE? -->
  <v-dialog v-model="showDeleteWorkoutModal">
    <v-card>
      <v-toolbar>
        <v-btn @click.prevent="showDeleteWorkoutModal = false"
               icon="mdi-close"
        ></v-btn>
        <h2>Confirm Delete</h2>
      </v-toolbar>

      <v-card-text>
        <p class="py-4 text-red-lighten-1 font-weight-bold">Are you <i>SURE</i> you want to delete this Workout Log?</p>

        <div class="d-flex justify-space-between align-center">
          <v-btn @click.prevent="showDeleteWorkoutModal = false"
                 variant="outlined"
                 color="grey"
                 density="compact"
                 class="text-capitalize"
          >Cancel</v-btn>
          <v-btn @click.prevent="forrealForrealDeleteOneWorkoutLog"
                 color="red-lighten-1"
                 class=""
          >YES, DELETE</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>


</div>
</template>

<style scoped lang="scss">
#page-workout-one {
  max-width: 700px;
  margin: 0 auto;

  .allow-new-line { white-space: pre-line; }
}
</style>
